/**
 * This version is bumped by `bumpAppVersion` script.
 */
export const appVerGenerated = '5.5.1'
